import { render, staticRenderFns } from "./MediaPackageDelete.vue?vue&type=template&id=272d422a&"
import script from "./MediaPackageDelete.vue?vue&type=script&lang=js&"
export * from "./MediaPackageDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports